import { useDesign } from '@/contexts/DesignContext'
import { cn } from '@/lib/cn'

export function BrandLogo({
  className,
  height = 28,
}: {
  className?: string
  height?: number
}) {
  const { logoUrl, design } = useDesign()

  return (
    <img
      src={logoUrl}
      alt={design.pwa.title}
      height={height}
      className={cn('w-auto object-contain', className)}
      style={{ height }}
      draggable={false}
    />
  )
}
